<template>
  <div class="splash">
    <NavBar titleTranslationPath="login.title" back noPadding />
    <form class="form" @submit.prevent="loginUser()">
      <div class="field">
        <label for="field-email">
          <NewTranslation path="login.mail.label"></NewTranslation>
        </label>
        <div class="field-input">
          <font-awesome-icon icon="envelope" />
          <input
            v-model="email"
            ref="email"
            type="email"
            id="field-email"
            :placeholder="translate('login.mail.placeholder')"
            required
          />
        </div>
      </div>
      <div class="field">
        <label for="field-password">
          <NewTranslation path="login.password.label"></NewTranslation>
        </label>
        <div class="field-input">
          <font-awesome-icon icon="fingerprint" />
          <input
            v-model="password"
            ref="password"
            type="password"
            id="field-password"
            :placeholder="translate('login.password.placeholder')"
            required
          />
        </div>
      </div>
      <button style="visibility: hidden;"></button>
    </form>
    <!-- Login Button -->
    <div class="loginBtn button firstButton" center @click="loginUser">
      <NewTranslation path="login.submit.button" />
      <font-awesome-icon icon="chevron-circle-right" class="btn-icon" />
    </div>
    <!-- Register Link -->
    <router-link class="button loginBtn grayBtn" :to="{ name: $namedRoutes.register }">
      <NewTranslation path="login.goTo.registerAccount" />
      <font-awesome-icon icon="plus-circle" class="btn-icon" />
    </router-link>
    <!-- Confirmation Code Link -->
    <router-link class="button loginBtn whiteBtn" :to="{ name: $namedRoutes.registerConfirmation }">
      <NewTranslation path="login.goTo.confirmationCode" style="" />
      <font-awesome-icon icon="check-circle" class="btn-icon" />
    </router-link>
    <!-- Password Reset Link -->
    <router-link class="button loginBtn whiteBtn" :to="{ name: $namedRoutes.requestPasswordReset }">
      <NewTranslation path="login.goTo.passwordReset" style="" />
      <font-awesome-icon icon="question-circle" class="btn-icon" />
    </router-link>
    <TabBar />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import Button from '@/components/Button.vue';
import Logo from '@/components/Logo.vue';
import TabBar from '@/components/TabBar';
import NewTranslation from '@/components/i18n/NewTranslation';
import i18next from 'i18next';
import AuthApi from '@/app/api/AuthApi';
import { NamedRoutes } from '@/routes/routes';
import AuthRedirect from '@/app/utils/AuthRedirect';

export default {
  components: {
    NewTranslation,
    NavBar,
    Button,
    Logo,
    TabBar,
  },
  data: () => {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    translate(path, params) {
      return i18next.t(path, params);
    },
    loginUser() {
      const fields = document.querySelectorAll('input[required]');

      let invalidField = false;
      for (let i = 0; i < fields.length; i++) {
        if (!fields[i].reportValidity()) {
          invalidField = true;
          break;
        }
      }

      if (!invalidField) {
        this.email = this.email.toLowerCase();
        AuthApi.login(this.email, this.password)
          .then(data => this.afterLogin(data))
          .catch(error => this.onLoginError(error));
      }
    },
    async afterLogin(data) {
      this.$store.dispatch('loginUser', data.user);
      const redirectRoute = AuthRedirect.getRedirect();
      if (redirectRoute.name) {
        await this.$router.push(redirectRoute);
        AuthRedirect.resetRedirectData();
        return;
      }
      await this.$router.push({ name: NamedRoutes.benefitsOverview });
    },
    onLoginError(error) {
      const response = error.response;
      if (response.status === 403) {
        this.onMultipleSessionError(response);
      } else if (response) {
        const message = response.data.message || i18next.t('login.requestError.dialog.validation.message');
        this.showError(message, i18next.t('login.requestError.dialog.validation.title'));
      } else {
        this.showError(error, i18next.t('login.requestError.dialog.unknown.title'));
      }
    },
    onMultipleSessionError(errorResponse) {
      const destroyCode = errorResponse.data ? errorResponse.data.code : null;
      console.log('Multiple sessions detected', 'code:', destroyCode, errorResponse.status);
      this.showError(i18next.t('login.multiSession.dialog.body'), i18next.t('login.multiSession.dialog.title'), () => {
        this.destroySession(destroyCode);
      });
    },
    destroySession(destroyCode) {
      this.$store
        .dispatch('destroySessions', destroyCode)
        .then(() => AuthApi.login(this.email, this.password))
        .then(data => this.afterLogin(data))
        .catch(err => this.showError('Session Destroy Failed'));
    },
    showError(message, title, submit) {
      const overlayData = {
        title,
        message,
      };

      if (submit) {
        overlayData.submit = submit;
      }

      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: overlayData,
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.splash
  min-height: 100vh
  height: 100%
  background-image: url(../../assets/splash.png)
  background-position: center center
  display: flex
  flex-direction: column
  align-items: center
  color: #fff
  padding: 20px 20px 80px

.pagetitle
  margin-top: 50px

.appicon
  margin-top: 70px
  width: 30px
  height: 40px

.form
  margin-top: 10px
  padding-bottom: 0px
  width: 100%

  .field
    display: flex
    flex-direction: column

    & + .field
      margin-top: 20px

    input[type="text"],
    input[type="password"],
    input[type="email"],
    select
      color: #454F63
      border-radius: 3px
      border: 1px solid #B3BAC8
      padding: 15px 15px 15px 45px
      margin-top: 5px
      background-color: #fff
      font-size: 1rem
      font-family: inherit
      width: 100%

    select,
    input[type="date"]
      -webkit-appearance: textfield
      appearance: textfield

    &-input
      position: relative

      svg
        color: #000
        position: absolute
        bottom: 0
        top: 5px
        left: 20px
        width: 15px
        margin-top: auto
        margin-bottom: auto

.changetologin
  margin-top: 10px
  text-decoration: underline

.firstButton
  margin-top: 0

.loginBtn
  border-radius: 10px
  background-color: #1db2d1
  color: #fff
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2)
  display: flex
  justify-content: space-between

  .btn-icon
    width: 20px
    height: 20px

.loginBtn.grayBtn
  background-color: #4a5062

.loginBtn.whiteBtn
  background-color: #fff
  color: #4a5062
</style>
